import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { AdminBrandBannerContextOperationsResponse } from './admin-brand-banner-context-operations.response';
import { AdminBrandBannerStatus } from '../../enums/admin-brand-banner-status';

@jsonObject
export class AdminBrandBannerDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly status!: AdminBrandBannerStatus;

  @jsonMember(String)
  public readonly url?: Nillable<string>;

  @jsonMember(Date)
  public readonly createdAt!: Nillable<Date>;

  @jsonMember(Date)
  public readonly visibilityStartDate?: Nillable<Date>;

  @jsonMember(Date)
  public readonly visibilityEndDate?: Nillable<Date>;

  @jsonMember(MultimediaResponse)
  public readonly file!: MultimediaResponse;

  @jsonMember(MultimediaResponse)
  public readonly smallFile?: Nillable<MultimediaResponse>;

  @jsonMember(Number)
  public readonly redirects!: number;

  @jsonMember(AdminBrandBannerContextOperationsResponse)
  public readonly contextOperations!: AdminBrandBannerContextOperationsResponse;
}
